import axios from 'axios';
import * as React from 'react';
import { requestApTemplateById } from '../asyncHelpers/actionPlanTemplateService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { ApTemplate, GetApTemplateByIdRequest } from '../sic-lib/types/ApTemplate';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncDeleteView
 *
 * @description
 * React hook providing request state managment and cancellation for the
 * requestDeleteView HTTP request
 */
export default function useAsyncGetApTemplateById() {
    const request_token = axios.CancelToken.source();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncGetApTemplateById = async (
        reqData: GetApTemplateByIdRequest,
    ): Promise<ApTemplate | undefined> => {
        try {
            setRequestStatus(RequestStatus.none);

            const { data } = await requestApTemplateById(reqData.templateId, request_token.token);

            setRequestStatus(RequestStatus.success);

            return data;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast(
                    'Error while retrieving selected Action Plan Template',
                );

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncGetApTemplateById,
    };
}
